import { render, staticRenderFns } from "./PPagination.vue?vue&type=template&id=30f3a73f&"
import script from "./pPagination.ts?vue&type=script&lang=ts&"
export * from "./pPagination.ts?vue&type=script&lang=ts&"
import style0 from "./PPagination.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VPagination,VSelect})
